import { Link } from "react-router";
import { ChevronRight } from "lucide-react";
import { Icon } from "../ui";

export type Crumb = { label: string; to?: string };

/** Where this page sits in the catalogue. The last crumb is the page itself. */
export function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="type-small">
      <ol className="m-0 flex list-none flex-wrap items-center gap-x-1.5 gap-y-1 p-0">
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex min-w-0 items-center gap-1.5">
            {index > 0 && <Icon icon={ChevronRight} size={14} className="text-ink-300" />}
            {item.to ? (
              <Link to={item.to} className="border-b-0 text-text-link hover:text-text-link-hover">
                {item.label}
              </Link>
            ) : (
              <span aria-current="page" className="text-text-strong">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
